
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/ai",
      function () {
        return require("private-next-pages/jobs/ai/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/ai"])
      });
    }
  